import jQuery from 'jquery';
import '@lottiefiles/lottie-player';

import Timeline from './components/timeline';

jQuery(($) => {
    let timeline = new Timeline();
});
